import type {Components, Theme} from '@mui/material/styles';

export const skeletonOverrides: Components<Theme>['MuiSkeleton'] = {
    styleOverrides: {
        text: {
            transform: 'scale(1)',
        },
    },
};
